<template>
  <div class="table">
    <div class="container">
      <div class="handle-box">
        <el-form :model="queryCondition" ref="queryCondition" :rules="rules" label-position="right" label-width="120px" class="searchForm">
          <el-row :gutter="20">
            <el-col :span="6">
              <el-form-item label="模块" prop="module">
                <el-select v-model="queryCondition.module" @change="moduleChange">
                  <el-option :key="index" v-for="(item,index) in moduleOptions" :label="item.name" :value="item.code"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="数据字典" prop="type">
                <el-select v-model="queryCondition.type">
                  <el-option :key="index" v-for="(item,index) in typeOptions" :label="item.name" :value="item.code"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row type="flex" justify="center" align="middle">
            <el-button size="mini" @click="onSearch" type="primary">查询</el-button>
            <el-button size="mini" @click="onReset" type="primary">重置</el-button>
          </el-row>
        </el-form>
      </div>
      <el-row class="action-btn-row">
        <el-button size="mini" class="btn" type="primary" @click="onAdd" v-acl="DATA_DICTIONARY_ADD">新增</el-button>
      </el-row>
      <el-row>
        <el-table :data="tableData" @selection-change="handleSelectionChange" max-height="425" border stripe style="width: 100%">
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column prop="code" sortable :sort-method="(a,b) => sortMethods(a ,b , 'code')" label="字典项编码" width="180">
            <template slot-scope="scope">
              <el-button @click="onDetail(scope.row)" type="text" size="small">{{scope.row.code}}</el-button>
            </template>
          </el-table-column>
          <el-table-column prop="chineseValue" sortable :sort-method="(a,b) => sortMethods(a ,b , 'chineseValue')" label="字典项名称" width="180"></el-table-column>
          <el-table-column prop="comments" sortable :sort-method="(a,b) => sortMethods(a ,b , 'comments')" label="说明"></el-table-column>
          <el-table-column prop="updateByName" sortable :sort-method="(a,b) => sortMethods(a ,b , 'updateByName')" label="更新人"></el-table-column>
          <el-table-column prop="updateDate" sortable :sort-method="(a,b) => sortMethods(a ,b , 'updateDate')" label="更新时间"></el-table-column>
        </el-table>
        <div class="pagination">
          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="queryCondition.pageNum" :page-sizes="pageSizeList" :page-size="queryCondition.pageSize" :layout="pageLayout" :total="totalCount" :page-count="pages">
          </el-pagination>
        </div>
      </el-row>
      <el-dialog title="编辑字典项" :visible.sync="dialogVisible" width="30%" :close-on-click-modal="false" @close="onClose">
        <el-form ref="addForm" :model="addForm" :rules="addFormRules" label-width="100px">
          <el-form-item label="数据字典" prop="type">
            <el-input v-model="addForm.type" disabled></el-input>
          </el-form-item>
          <el-form-item label="字典项编码" prop="code">
            <el-input v-model="addForm.code" disabled></el-input>
          </el-form-item>
          <el-form-item label="字典项名称" prop="chineseValue">
            <el-input v-model="addForm.chineseValue"></el-input>
          </el-form-item>
          <el-form-item label="说明" prop="comments">
            <el-input v-model="addForm.comments" type="textarea" :rows="2" maxlength="500" show-word-limit></el-input>
          </el-form-item>
        </el-form>
        <el-row type="flex" justify="center">
          <el-button size="mini" class="btn" type="primary" @click="onSave" :disabled="isSaveDisabled" :loading="isSaveLoading">保存</el-button>
          <el-button size="mini" class="btn" type="primary" @click="onClose">取消</el-button>
        </el-row>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import nutriApi from "@/api/Nutrition/index";
import paginationMixin from '@/mixins/pagitionMixin';
// import { fileService } from "@/api/common/file-utils";
// import store from '@/store/index'
import IcSelect from "@/components/common/icSelect";
export default {
  name: 'Window',
  mixins: [paginationMixin],
  components: { IcSelect },
  data() {
    return {
      queryCondition: {
        pageSize: 15,
        pageNum: 1,
        module: "",
        type: "",
      },
      totalCount: 0,
      pages: 1,
      moduleOptions: [],
      typeOptions: [],
      dialogVisible: false,
      isSaveDisabled: false,
      isSaveLoading: false,
      tableData: [],
      addForm: {
        type: "",
        code: "",
        chineseValue: "",
        comments: "",
      },
      multipleSelection: [],
      inspectIdList: [],
      rules: {
        module: [
          { required: true, message: '请选择模块', trigger: 'change' },
        ],
        type: [
          { required: true, message: '请选择数据字典', trigger: 'change' },
        ],
      },
      addFormRules: {
        chineseValue: [
          { required: true, message: '请输入字典项名称', trigger: 'blur' },
        ],
      }
    };
  },
  mounted() {
    this.queryData()
    this.getModuleOption()
  },
  methods: {
    queryData() {
      this.$refs['queryCondition'].validate((valid) => {
        if (valid) {
          nutriApi.dictQueryPage(this.queryCondition).then((res) => {
            console.log("🚀 ~ file: detectionWindowPeriod.vue:135 ~ nutriApi.findListPage ~ res:", res)
            this.tableData = res.resultData
            this.totalCount = res.totalCount
          })
        }
      })
    },
    getModuleOption() {
      nutriApi.getModuleList().then((res) => {
        console.log("🚀 ~ file: dataConfig.vue:226 ~ nutriApi.getModuleList ~ res:", res)
        if (res.code === '200') {
          this.moduleOptions = res.data
        }
      })
    },
    moduleChange(e) {
      console.log("🚀 ~ file: dataConfig.vue:218 ~ moduleChange ~ e:", e)
      nutriApi.getDictTypeList(e).then((res) => {
        console.log("🚀 ~ file: dataConfig.vue:236 ~ nutriApi.getDictTypeList ~ res:", res)
        if (res.code === '200') {
          this.typeOptions = res.data
        }
      })
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
      this.inspectIdList = []
      val.forEach(ele => {
        this.inspectIdList.push(ele.inspectId)
      })
    },
    onAdd() {
      if (!this.queryCondition.module) {
        this.$message.error('请选择模块')
        return false
      }
      if (!this.queryCondition.type) {
        this.$message.error('请选择数据字典')
        return false
      }
      this.dialogVisible = true
      this.addForm = {
        type: this.queryCondition.type,
        code: "",
        chineseValue: "",
        comments: "",
      }
    },
    onDetail(row) {
      this.dialogVisible = true
      this.addForm = Object.assign({}, row)
    },
    onSave() {
      this.$refs['addForm'].validate((valid) => {
        if (valid) {
          this.isSaveDisabled = true
          this.isSaveLoading = true
          nutriApi.saveDictAdd(this.addForm).then((res) => {
            console.log("🚀 ~ file: dataConfig.vue:173 ~ nutriApi.saveDictAdd ~ res:", res)
            this.isSaveDisabled = false
            this.isSaveLoading = false
            if (res.code === '200') {
              this.$message.success('保存成功')
              this.dialogVisible = false
              this.queryData()
            }
          }).catch(error => {
            console.log("🚀 ~ error.response:", error.response)
            this.isSaveDisabled = false
            this.isSaveLoading = false
          })
        }
      })
    },
    onSearch() {
      this.queryCondition.pageNum = 1;
      this.queryData()
    },
    onReset() {
      this.queryCondition = {
        pageSize: 15,
        pageNum: 1,
        module: "",
        type: "",
      }
      this.tableData = []
    },
    sortMethods(a, b, proptype) {
      var prop
      if (proptype === 'updateDate') {
        prop = 'updateDateMiss'
      }else {
        prop = proptype
      }
      if (a[prop] === null || a[prop] === undefined) {
        return 1; // 将空值排在后面
      } else if (b[prop] === null || b[prop] === undefined) {
        return -1; // 将空值排在后面
      } else {
        // 自定义排序逻辑
        // return a[prop] - b[prop]; // 示例中使用数字类型的比较
        if (typeof a[prop] === 'string' && typeof b[prop] === 'string') {
          return a[prop].localeCompare(b[prop])
        } else {
          return a[prop] - b[prop];
        }
      }
    },
    handleSizeChange(val) {
      this.queryCondition.pageSize = val
      this.queryData()
    },
    handleCurrentChange(val) {
      this.queryCondition.pageNum = val
      this.queryData()
    },
    onClose() {
      this.dialogVisible = false
      this.$refs['addForm'].resetFields();
    },
  }
}
</script>
  